define("shared/components/shared/button/upgrade", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if (has-block)}}
    {{yield (fn this.upgrade @feature @location @socialProfileType) this.text}}
  {{else}}
  
    <Shared::Ui::Button
      @additional={{@additional}}
      @isDisabled={{this.isDisabled}}
      @onClick={{fn this.upgrade @feature @location @socialProfileType}}
      @size={{if @size @size "regular"}}
      @text={{this.text}}
      @variant={{this.variant}}
      class={{concat-classes "qa--collabs_upgrade_button" @class}}
      data-test-id="button-upgrade"
      ...attributes
    />
  {{/if}}
  */
  {
    "id": "qBdHcrzg",
    "block": "[[[41,[48,[30,8]],[[[1,\"  \"],[18,8,[[28,[37,3],[[30,0,[\"upgrade\"]],[30,1],[30,2],[30,3]],null],[30,0,[\"text\"]]]],[1,\"\\n\"]],[]],[[[1,\"\\n  \"],[8,[39,4],[[16,0,[28,[37,5],[\"qa--collabs_upgrade_button\",[30,4]],null]],[24,\"data-test-id\",\"button-upgrade\"],[17,5]],[[\"@additional\",\"@isDisabled\",\"@onClick\",\"@size\",\"@text\",\"@variant\"],[[30,6],[30,0,[\"isDisabled\"]],[28,[37,3],[[30,0,[\"upgrade\"]],[30,1],[30,2],[30,3]],null],[52,[30,7],[30,7],\"regular\"],[30,0,[\"text\"]],[30,0,[\"variant\"]]]],null],[1,\"\\n\"]],[]]]],[\"@feature\",\"@location\",\"@socialProfileType\",\"@class\",\"&attrs\",\"@additional\",\"@size\",\"&default\"],false,[\"if\",\"has-block\",\"yield\",\"fn\",\"shared/ui/button\",\"concat-classes\"]]",
    "moduleName": "shared/components/shared/button/upgrade.hbs",
    "isStrictMode": false
  });
  /**
   * @module Components
   */

  /**
   * @class Shared::Button::Upgrade
   * @extends Component
   *
   * This component renders a button whose sole purpose is to propmpt a user to upgrade their current payment plan.
   * Currently it does this by always redirecting the user to our "plans" page where they can change their current plan.
   * In the future, once we have our new pricing system in place, this button will trigger a modal that runs the
   * user through the process of adding an Add-On to their current plan, unless they are on a Grandfathered plan,
   * in which case it will open a modal that runs them through the process of migrating to the new pricing system.
   *
   * It also automatically tracks all clicks to segment via the "clicked-upgrade-button event"
   *
   * This component extends the SharedButton component, meaning that it can accept all the arguments that the SharedButton accepts,
   * in addition to the arguments specific to the Shared::Button::Upgrade. See documentation for SharedButton to get information
   *
   *
   * Inherited Arguments (See SharedButton for usage details):
   * - [size] (String) Button Size, Available options: "large", "small", "regular" (default: "regular")
   * - [type] (String) Button color styling, Available options: "primary", "default", "proceed", "outline", "danger", "mute" (default: "proceed")
   * - [text] (String) The text displayed on the button, If this component is invoked as a block, the block contents will be used instead of this property. (default: "Upgrade")
   * - [additional] (String) Button options, Available options: "rounded", "circle", "block", "outline", "danger" (default: null)
   * - [isDisabled] (Boolean) Whether or not the button is disabled (default: false)
   *
   * Arguments:
   * - feature (String) The relevant feature that the user is prompted to upgrade for.
   * - [trialText] (String) Text that can be passed in to show a specific trial copy. if trialText is not passed in, and user is on a trial they'll see default copy
   * - [location] (String) The human-readable location of this button. This will be passed to the segment tracking event.
   * Although optional, it this property is strongly recommended to keep every instance of this button unique from a tracking perspective.
   * The value of this "location" should be provided by the product team.
   * - [confirmLeave] (Boolean) Whether we want to show the dialogManager confirming the user's intent to leave the page while discarding unsaved changes
   * - [seamlessCheckoutSuccessCallback] callback to run after checkout completion
   *
   * Examples:
   *
   * Simple Usage:
   * ```
   * <Shared::Button::Upgrade />
   * ```
   *
   * Inline Usage with all options:
   * ```
   * <Shared::Button::Upgrade
   *  @feature="users"
   *  @text="Click Me!"
   *  @size="large"
   *  @buttonType="outline"
   *  @additional="block"
   *  @isDisabled={{true}}
   *  @location="example in the docs"
   *  @confirmLeave={{true}}
   *  @seamlessCheckoutSuccessCallback={{@closeModal}}
   * />
   * ```
   *
   * Block Usage:
   *
   * When invoked as a Block component, no HTML is provided.
   * Instead, any custom HTML/Components can be used inside the block.
   * Yielded Values (positional):
   * 1. A function used to perform the "upgrade" action.
   *    This should be used whenever custom functionality is not required.
   * 2. The computed text property. This should always be used as it
   *     will dynamically show the correct copy for users that are eligible for a trial.
   * ```
   * <Shared::Button::Upgrade
   *  @text="Please Upgrade"
   *  @feature="analytics"
   *  @location="block example in the docs"
   *  as |upgradeAction text|>
   *    <img src="https://someimg.com" onclick={{action upgradeAction}} alt={{text}}>
   * </Shared::Button::Upgrade>
   * ```
   */
  let UpgradeComponent = _exports.default = (_class = class UpgradeComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor5, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor6, this);
      _initializerDefineProperty(this, "router", _descriptor7, this);
    }
    get isDisabled() {
      return this.args.isDisabled || false;
    }
    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }
    get isEnterpriseSubscription() {
      return this.subscriptions.isEnterpriseSubscription;
    }
    get text() {
      if (this.auth?.currentAccount?.canTrialPlan) {
        return this.args.trialText ? this.args.trialText : this.intl.t('shared_phrases.upgrade_trial');
      }
      if (this.args.text) {
        return this.args.text;
      }
      return this.intl.t('shared_phrases.upgrade_plan');
    }
    get variant() {
      return this.args.type || this.args.variant || 'proceed';
    }
    async upgrade(feature, location, socialProfileType, event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.isEnterpriseSubscription) {
        this.args.track?.();
        this.subscriptions.displayEnterpriseSupportAlert();
        return;
      }
      if (this.args.additionalAction) {
        this.args.additionalAction();
      }
      if (this.isMobileSubscription) {
        this.args.track?.();
        this.subscriptions.openMobileRedirectModal();
        return;
      }
      if (this.seamlessCheckoutManager.canSeamlessCheckout) {
        this.args.track?.();
        this.seamlessCheckoutManager.upgrade({
          feature,
          confirmLeave: this.args.confirmLeave,
          location,
          socialProfileType,
          successCallback: this.args.seamlessCheckoutSuccessCallback,
          isSimplifiedCheckout: this.args.isSimplifiedCheckout
        });
        return;
      }
      if (this.args.confirmLeave) {
        const title = this.args.confirmCopy?.title || this.intl.t('shared_phrases.are_you_sure');
        const confirmArgs = this.args.confirmCopy?.args || {
          description: this.intl.t('post.unsaved_modal.message'),
          confirmButton: this.intl.t('shared_words.continue')
        };
        const didConfirm = await this.dialogManager.confirmation(title, confirmArgs);
        if (!didConfirm) {
          return;
        }
      }
      this.errors.log('Reached the end of the upgrade button without upgrading. This should never happen.', {
        feature,
        location,
        socialProfileType,
        event
      });
      this.args.track?.();
      this.subscriptions.trackUpgrade(location);
      this.router.transitionTo('account.subscription');
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "upgrade", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "upgrade"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, UpgradeComponent);
});